import { bootstrapApplication } from "@angular/platform-browser";
import { environment } from "@environments/environment";
import * as Sentry from "@sentry/angular";

import { App } from "./app/app";
import { appConfig } from "./app/app.config";

Sentry.init({
  dsn: "https://a4c7a359c4527581fbb62d68c0e7c075@o4510862333313024.ingest.us.sentry.io/4511865115312128",
  environment: environment.environmentName || "development",
  enabled: environment.environmentName === "production" || environment.environmentName === "staging",
  tracesSampleRate: 0.01,
});

bootstrapApplication(App, appConfig).catch(err => console.error(err));
